import { sortBy, some } from 'lodash'

import * as actionType from '../constants/constant.action'

const defaultState = {
  formStatus: true,
  filter: {
    distance: '20',
    sortBy: 'distance',
  },
  aofList: [],
  providerList: [],
}

const referralProviderReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_SPECIALTY_LIST_REQUESTED:
      return {
        ...state,
        ...action.payload,
      }
    case actionType.GET_SPECIALTY_LIST_SUCCESS:
      const unsortedSpecialtyList = action.payload.specialtyList
        .filter(
          specialtyItem => specialtyItem.isProvider && !!specialtyItem.code
        )
        .map(specialtyItem => ({
          label: specialtyItem.specialty,
          value: specialtyItem.code,
        }))
      const specialtyList = unsortedSpecialtyList.sort((a, b) => {
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }
        return 0
      })

      return {
        ...state,
        referralWorkflow: action.payload.referralWorkflow,
        referralTool: action.payload.referralTool,
        specialtyList,
      }

    case actionType.GET_SPECIALTY_LIST_FAILURE:
      return {
        ...state,
        ...action.payload,
        serverError: true,
      }
    case actionType.GET_AREA_OF_FOCUS_REQUESTED:
      return {
        ...state,
        ...action.payload,
      }
    case actionType.GET_AREA_OF_FOCUS_SUCCESS:
      // let aofList = [
      //   {value: "Hip & Femur", label: "Hip & Femur"},
      //   {value: "Major LEJR", label: "Major LEJR"},
      //   {value: "Major UEJR", label: "Major UEJR"},
      //   {value: "Spinal Fusion", label: "Spinal Fusion"},
      //   {value: "Back & Neck", label: "Back & Neck"}
      // ]
      return {
        ...state,
        // aofList,
        ...action.payload,
      }
    case actionType.CLEAN_AREA_OF_FOCUS:
      return {
        ...state,
        referralProvider: {
          ...state.referralProvider,
          aofList: [],
        },
      }
    case actionType.GET_AREA_OF_FOCUS_FAILURE:
      return {
        ...state,
        ...action.payload,
        serverError: true,
      }
    case actionType.GET_LOCATION_REQUESTED:
      return {
        ...state,
        ...action.payload,
      }
    case actionType.GET_LOCATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case actionType.GET_LOCATION_FAILURE:
      return {
        ...state,
        ...action.payload,
      }
    case actionType.FIND_PROVIDERS_REQUESTED:
      return {
        ...state,
        ...action.payload,
        loading: true,
      }

    case actionType.TOGGLE_NEIGHBORHOOD_PROVIDER_FLAG:
      const flag = !state.isMedicalNeighborhood

      return {
        ...state,
        isMedicalNeighborhood: flag,
      }

    case actionType.FIND_PROVIDERS_SUCCESS:
      return {
        ...state,
        providerList: action.payload.providerList,
        providerListResult: action.payload.providerList,
        distance: action.payload.distance,
        formStatus: false,
        loading: false,
        errorMessage: '',
      }
    case actionType.SEARCH_FOR_PROVIDER_ERRORS:
      // setTimeout(
      //   () => {
      //     alert("Hello")
      //     return {
      //       ...state,
      //       errorMessage: null,
      //       loading: false
      //     }
      //   }
      // )

      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
      }

    case actionType.FIND_PROVIDERS_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
        serverError: true,
      }

    case actionType.MEMBER_SEARCH_EMPTY:
      return {
        ...state,
        formStatus: true,
      }

    case actionType.BACK_TO_SEARCH:
      return {
        ...state,
        formStatus: true,
      }

    case actionType.GET_PROVIDER_SEARCH:
      const { payload } = action
      const searchTextFilter = val =>
        (val.providerNameTitle !== null &&
          `${val.providerNameTitle ? val.providerNameTitle : ' '}`
            .toLowerCase()
            .indexOf(payload.toLowerCase()) !== -1) ||
        (val.practiceName !== null &&
          `${val.practiceName ? val.practiceName : ' '}`
            .toLowerCase()
            .indexOf(payload.toLowerCase()) !== -1) ||
        (val.phone !== null && `${val.phone}`.indexOf(payload) !== -1) ||
        (val.practitionerNpi && val.practitionerNpi.indexOf(payload) !== -1)
      const searchProviderList =
        state.providerListResult.filter(searchTextFilter)
      const searchMedicalNeighborhoodCollection = state.providerListResult
        .filter(searchTextFilter)
        .filter(filterMedicalNeighborhood)
      return {
        ...state,
        providerList: searchProviderList,
        medicalNeighborhoodCollection: searchMedicalNeighborhoodCollection,
      }

    case actionType.EMPTY_PROVIDER_SEARCH:
      return {
        ...state,
        searchText: null,
        providerList: [...state.providerListResult],
        medicalNeighborhoodCollection: state.providerListResult.filter(
          filterMedicalNeighborhood
        ),
        searchProviderList: [],
      }

    case actionType.CLEAN_PROVIDER_SEARCH_ERROR:
      return {
        ...state,
        errorMessage: null,
      }

    case actionType.SORT_BY_DISTANCE:
      const sortByDistance = sortBy(state.providerList, 'distance')
      return {
        ...state,
        providerList: sortByDistance,
      }

    case actionType.SORT_BY_SCORE:
      const sortByScore = sortBy(state.providerList, 'score')
      return {
        ...state,
        providerList: sortByScore,
      }

    case actionType.PROVIDER_SELECTION_LIMIT_REACHED:
      const carepointPayload = action.payload
      const newProviderList = state.providerList.map(v => {
        if (v.showWarning === true) {
          v.showWarning = false
          return v
        }
        if (v.npi === carepointPayload.npi && v.key === carepointPayload.key) {
          v.showWarning = true
          return v
        }
        return v
      })

      return {
        ...state,
        providerList: newProviderList,
      }

    case actionType.PROVIDER_SELECTION_LIMIT_REACHED_REMOVE:
      const newProviderList1 = state.providerList.map(v => {
        if (v.showWarning === true) {
          v.showWarning = false
          return v
        }
        return v
      })

      return {
        ...state,
        providerList: newProviderList1,
      }

    /*
     case actionType.SORT_BY_TOP_50_SCORE:
      let sortByTop50Score = state.providerList.filter( 
        (obj) => obj.score > 50
      )
      */

    default:
      return state
  }
}

const filterMedicalNeighborhood = provider =>
  provider.isMedicalNeighborhood === true

export default referralProviderReducer
